
import {
  defineComponent, Ref, ref, computed,
} from 'vue';
import { useRoute } from 'vue-router';
import { IMedia } from '@/types/interfaces';
import { useMainStore } from '@/store/mainStore';
import { useDriveStore } from '../../store/driveStore';
import { MEDIA_TYPES, PHOTO_VIEW_TYPE, SHARE_SETTINGS } from '@/types/enums';
import AppQuestionPopUp from '@/components/AppQuestionPopUp.vue';
import { lowResUrlByViewTypeByUrl } from '@/helpers/lowResPhotoUrl';
import MixedMediaPopUp from '@/components/BottomPopUp/PopUpTypes/MixedMediaPopUp.vue';
import AppRenameFile from '@/components/AppRenameFile.vue';

export default defineComponent({
  emits: ['on-select'],
  props: {
    file: { type: Object as () => IMedia, required: true },
    hideTitle: { type: Boolean, default: false },
    hideDelete: { type: Boolean, default: false },
    columnView: { type: Boolean, default: false },
    preventOpen: { type: Boolean, default: false },
    selectedId: { type: String, default: '' },
    selector: { type: Boolean, default: false },
    hideAuthor: { type: Boolean, default: false },
    isMixed: { type: Boolean, default: false },
    showDots: { type: Boolean, default: true },
  },
  components: {
    AppRenameFile,
    AppQuestionPopUp,
    MixedMediaPopUp,
  },
  setup(props, { emit }) {
    const pdfFile = ref<null|any>(null);
    const mainStore = useMainStore();
    const driveStore = useDriveStore();
    const route = useRoute();

    const isQuestionPopUp: Ref<boolean> = ref(false);

    const isNetwork = computed(() => route.meta.isNetwork);
    const reshareAllowed = computed(() => props.file.shareSettings?.includes(SHARE_SETTINGS.RESHARE_ALLOWED));

    const isSelectedFromParent = computed(() => props.file.id === props.selectedId);
    const isMediaSettingsPopUp = ref(false);
    const fileRenamePopUp = ref(false);
    const showMenuDots = computed(() => {
      if (props.showDots) {
        return isNetwork.value || props.columnView;
      }
      if (!props.showDots) {
        return false;
      }
      return true;
    });

    function deleteFile() {
      isQuestionPopUp.value = false;
      driveStore.deleteMedia(props.file.id, MEDIA_TYPES.FILES);
    }

    async function openFile() {
      if (props.selector) {
        emit('on-select', props.file.id);
        return;
      }

      if (props.preventOpen) {
        return;
      }

      driveStore.appPhotoViewMedia = { ...props.file, isMixed: props.isMixed };
    }

    const photoUrl = computed(() => {
      if (props.file?.owner?.photo?.url) {
        return lowResUrlByViewTypeByUrl(props.file.owner.photo.url, PHOTO_VIEW_TYPE.WHSML);
      }
      // eslint-disable-next-line global-require
      return require('@/assets/img/mockup/profile.svg');
    });
    const authorName = computed(() => `${props.file.owner.firstName} ${props.file.owner.lastName}`);

    return {
      mainStore,
      isQuestionPopUp,
      isNetwork,
      photoUrl,
      authorName,
      isSelectedFromParent,
      reshareAllowed,
      deleteFile,
      openFile,
      pdfFile,
      isMediaSettingsPopUp,
      fileRenamePopUp,
      showMenuDots,
    };
  },
});
